var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9.25 4.66667V16.5833M9.25 4.66667H6.00893C5.53138 4.66667 5.07339 4.47352 4.73572 4.12969C4.39804 3.78588 4.20833 3.31956 4.20833 2.83333C4.20833 2.34711 4.39804 1.88079 4.73572 1.53697C5.07339 1.19315 5.53138 1 6.00893 1C8.52977 1 9.25 4.66667 9.25 4.66667ZM9.25 4.66667H12.4911C12.9686 4.66667 13.4266 4.47352 13.7643 4.12969C14.1019 3.78588 14.2917 3.31956 14.2917 2.83333C14.2917 2.34711 14.1019 1.88079 13.7643 1.53697C13.4266 1.19315 12.9686 1 12.4911 1C9.97023 1 9.25 4.66667 9.25 4.66667ZM2.83333 9.25H15.6667V14.5667C15.6667 15.5934 15.6667 16.1069 15.4668 16.499C15.2911 16.8439 15.0106 17.1244 14.6657 17.3002C14.2735 17.5 13.7601 17.5 12.7333 17.5H5.76667C4.7399 17.5 4.22652 17.5 3.83435 17.3002C3.48938 17.1244 3.20892 16.8439 3.03316 16.499C2.83333 16.1069 2.83333 15.5934 2.83333 14.5667V9.25ZM2.46667 9.25H16.0333C16.5468 9.25 16.8034 9.25 16.9995 9.15008C17.172 9.06217 17.3122 8.92202 17.4001 8.7495C17.5 8.55343 17.5 8.29676 17.5 7.78333V6.13333C17.5 5.61995 17.5 5.36326 17.4001 5.16718C17.3122 4.9947 17.172 4.85446 16.9995 4.76657C16.8034 4.66667 16.5468 4.66667 16.0333 4.66667H2.46667C1.95329 4.66667 1.69659 4.66667 1.50051 4.76657C1.32803 4.85446 1.1878 4.9947 1.09991 5.16718C1 5.36326 1 5.61995 1 6.13333V7.78333C1 8.29676 1 8.55343 1.09991 8.7495C1.1878 8.92202 1.32803 9.06217 1.50051 9.15008C1.69659 9.25 1.95329 9.25 2.46667 9.25Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.bf6a95e23e1fc1f1026cde1f5a382a36.svg";
export { ForwardRef as ReactComponent };